(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-reverie-cart"]) return;
  try {
    
document.querySelectorAll('[data-pet-edit-link]').forEach(link => { link.hidden = false; });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pet-studio-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pet-studio-customization')) {
  class PetStudioCustomization extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.photoUrls = new Map();
      this.retainedPhotos = new Map();
      this.form = this.querySelector('form');
      if (!this.form) return;
      const signal = this.controller.signal;
      this.button = this.querySelector('[data-pet-submit]');
      this.status = this.querySelector('[data-pet-submit-status]');
      this.variant = this.querySelector('[data-pet-variant]');
      this.specDriven = this.dataset.specDriven === 'true';
      this.editRequested = this.specDriven && new URL(window.location.href).searchParams.has('pr_edit');
      if (this.editRequested) this.querySelector('.pet-customization__fields').disabled = true;
      if (this.specDriven) {
        this.variant.disabled = false;
        this.querySelector('[data-pet-variant-fallback]').disabled = true;
        this.querySelector('[data-pet-enquire]').addEventListener('click', () => {
          const neck = this.querySelector('[data-pet-neck]');
          if (!neck.reportValidity()) return;
          const link = this.querySelector('[data-pet-contact-link]');
          const request = this.querySelector('[data-pet-lettering]').value.trim();
          const url = new URL(link.href, window.location.origin);
          url.searchParams.set('message', `Neck measurement: ${neck.value} cm\nLettering request: ${request || 'Not specified'}\nPending confirmation.`);
          window.location.assign(url.href);
        }, { signal });
        this.querySelector('[data-pet-quantity]').addEventListener('input', () => this.updateReview(), { signal });
      }
      this.querySelectorAll('[data-pet-gallery-image]').forEach((button) => button.addEventListener('click', () => {
        const image = this.querySelector('[data-pet-main-image] img');
        if (!image) return;
        image.src = button.dataset.petGalleryImage;
        image.style.transform = button.dataset.detailZoom ? 'scale(1.8)' : '';
        image.style.transformOrigin = '50% 55%';
        image.removeAttribute('srcset');
        image.alt = button.dataset.imageAlt;
        this.querySelectorAll('[data-pet-gallery-image]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      }, { signal }));
      this.petNames = this.querySelectorAll('[data-pet-name]');
      this.variant.addEventListener('change', () => this.updateVariant(), { signal });
      this.querySelectorAll('[data-pet-photo-submission]').forEach((input) => input.addEventListener('change', () => this.updateVariant(), { signal }));
      this.querySelector('select[data-pet-count-choice]')?.addEventListener('change', () => this.updateVariant(), { signal });
      this.petNames.forEach((input) => input.addEventListener('input', () => this.validateName(input), { signal }));
      this.querySelectorAll('[data-pet-photo]').forEach((input) => {
        input.addEventListener('change', () => this.updatePhoto(input), { signal });
        input.closest('[data-pet-photo-field]').querySelector('[data-pet-remove]').addEventListener('click', () => {
          input.value = '';
          this.clearPhoto(input);
          input.focus();
        }, { signal });
        if (input.files.length) this.updatePhoto(input);
      });
      this.form.addEventListener('submit', (event) => {
        if (this.editRequested) event.preventDefault();
        if (this.dataset.orderingAllowed !== 'true' || this.submitting || (this.editRequested && !this.cartEditor?.ready) || (this.specDriven && this.variant.selectedOptions[0]?.dataset.petProfile !== 'portrait')) {
          event.preventDefault();
          return;
        }
        this.petNames.forEach((input) => {
          input.value = input.value.trim();
          this.validateName(input);
        });
        this.querySelectorAll('[data-pet-photo]').forEach((input) => { if (!input.matches(':disabled')) this.validatePhoto(input); });
        if (!this.form.reportValidity() || this.variant.selectedOptions[0]?.dataset.available !== 'true') {
          event.preventDefault();
          return;
        }
        this.submitting = true;
        this.form.setAttribute('aria-busy', 'true');
        this.button.disabled = true;
        this.button.textContent = this.button.dataset.busyLabel;
        this.status.textContent = this.status.dataset.busyMessage;
        if (this.editRequested) this.cartEditor.save();
      }, { signal });
      this.form.addEventListener('reset', () => {
        queueMicrotask(() => {
          this.querySelectorAll('[data-pet-photo]').forEach((input) => this.clearPhoto(input));
          this.petNames.forEach((input) => input.setCustomValidity(''));
          this.resetSubmission();
        });
      }, { signal });
      window.addEventListener('pageshow', () => {
        this.resetSubmission();
        this.querySelectorAll('[data-pet-photo]').forEach((input) => {
          if (!input.files.length && !this.retainedPhotos.has(input)) this.clearPhoto(input);
          else if (!this.photoUrls.has(input)) this.updatePhoto(input);
        });
      }, { signal });
      this.resetSubmission();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.photoUrls?.forEach((url) => URL.revokeObjectURL(url));
      this.photoUrls?.clear();
    }
    validateName(input) {
      const name = input.value.trim();
      const limit = input.maxLength > 0 ? input.maxLength : 80;
      input.setCustomValidity((input.required && input.value && !name) || Array.from(name).length > limit ? input.dataset.nameError : '');
      if (this.specDriven && !input.required) input.removeAttribute('pattern');
      this.updateReview();
    }
    photosDeferred() {
      return this.specDriven && this.querySelector('[data-pet-photo-submission]:checked')?.value === 'Send after checkout';
    }
    updateVariant() {
      const option = this.variant.selectedOptions[0];
      if (option) this.querySelector('[data-pet-price]').textContent = option.dataset.price;
      const image = this.querySelector('[data-pet-main-image] img');
      if (image && option?.dataset.imageSrc && this.currentImageVariant !== option.value) {
        image.src = option.dataset.imageSrc; image.removeAttribute('srcset'); image.alt = option.dataset.imageAlt || ''; image.style.transform = '';
        this.currentImageVariant = option.value;
        this.querySelectorAll('[data-detail-zoom]').forEach(button => {
          button.dataset.petGalleryImage = option.dataset.imageSrc;
          button.dataset.imageAlt = option.dataset.imageAlt || '';
          const thumbnail = button.querySelector('img');
          if (thumbnail) { thumbnail.src = option.dataset.imageSrc; thumbnail.removeAttribute('srcset'); }
        });
        this.querySelectorAll('[data-pet-gallery-image]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.petGalleryImage === option.dataset.imageSrc && !button.dataset.detailZoom)));
      }
      if (this.specDriven) this.configurePetGroups(option);
      this.querySelectorAll('[data-pet-detail-variant]').forEach(panel => { panel.hidden = panel.dataset.petDetailVariant !== option?.value; });
      if (this.submitting) return;
      const enabled = this.dataset.orderingAllowed === 'true' && (!this.specDriven || option?.dataset.petProfile === 'portrait');
      this.button.disabled = !enabled || option?.dataset.available !== 'true' || (this.editRequested && !this.cartEditor?.ready);
      if (enabled) this.button.textContent = this.button.disabled ? this.button.dataset.unavailableLabel : this.button.dataset.readyLabel;
    }
    selectedPetCount(option = this.variant.selectedOptions[0]) {
      if (option?.dataset.petCountChoice === 'true') {
        const value = this.querySelector('select[data-pet-count-choice]')?.value;
        return ['1', '2'].includes(value) ? Number(value) : 0;
      }
      return Number(option?.dataset.petCount || 0);
    }
    configurePetGroups(option) {
      const count = this.selectedPetCount(option);
      const profile = option?.dataset.petProfile;
      const portrait = profile === 'portrait';
      const deferred = portrait && this.photosDeferred();
      const countChoice = this.querySelector('select[data-pet-count-choice]');
      if (countChoice) countChoice.disabled = !portrait || option?.dataset.petCountChoice !== 'true';
      this.dataset.petProfile = profile || 'unknown';
      this.dataset.petCount = String(count);
      this.querySelectorAll('[data-pet-portrait-content]').forEach((element) => { element.hidden = !portrait; });
      const intro = this.querySelector('[data-pet-intro]');
      if (intro) intro.textContent = profile === 'collar' ? intro.dataset.collarIntro : intro.dataset.portraitIntro;
      this.variant.name = this.dataset.orderingAllowed === 'true' && portrait ? 'id' : '';
      const size = option?.dataset.petSize || '';
      this.querySelector('[data-pet-size]').textContent = size;
      this.querySelectorAll('[data-pet-spec-size]').forEach(el => el.textContent = size);
      this.querySelectorAll('[data-pet-spec-count]').forEach(el => el.textContent = count === 1 ? (el.dataset.oneLabel || '1 pet') : (el.dataset.manyLabel || '[count] pets').replace('[count]', String(count)));
      this.querySelector('[data-pet-size-property]').value = size;
      this.querySelector('[data-pet-count-property]').value = count;
      const order = count === 3 ? 'Left: Photo 1; Centre: Photo 2; Right: Photo 3' : count === 2 ? 'Left: Photo 1; Right: Photo 2' : 'Photo 1';
      this.querySelector('[data-pet-order-property]').value = portrait ? order : '';
      this.querySelector('[data-pet-order-property]').disabled = !portrait || deferred;
      this.querySelectorAll('[data-pet-photo-submission]').forEach(input => { input.disabled = !portrait; });
      this.querySelector('[data-pet-photo-fields]').hidden = deferred;
      this.querySelector('[data-pet-later-info]').hidden = !deferred;
      const customisationStatus = this.querySelector('[data-pet-customisation-status]');
      customisationStatus.disabled = !portrait;
      customisationStatus.value = deferred ? 'Awaiting photos and details' : 'Photos supplied; awaiting review';
      this.querySelector('[data-pet-customisation-id]').disabled = !portrait;
      let preserved = false;
      this.querySelectorAll('[data-pet-group]').forEach((group) => {
        const number = Number(group.dataset.petGroup);
        const reference = group.dataset.petGroup === 'reference';
        const active = portrait && !deferred && (reference ? count === 1 : number <= count);
        group.hidden = !active;
        group.disabled = !active;
        const photo = group.querySelector('[data-pet-photo]');
        photo.required = active && !reference && !this.retainedPhotos.has(photo);
        const name = group.querySelector('[data-pet-name]');
        if (name) {
          name.required = active && count === 1;
          if (!name.required) name.removeAttribute('pattern');
          const label = group.querySelector('[data-pet-name-label]');
          label.textContent = count === 1 ? label.dataset.singleLabel : label.dataset.multiLabel;
          this.validateName(name);
          const position = number === 1 ? this.dataset.leftLabel : number === count ? this.dataset.rightLabel : this.dataset.centreLabel;
          group.querySelector('[data-pet-position]').textContent = count > 1 ? `· ${position}` : '';
        }
        if (!active && (photo.files.length || this.retainedPhotos.has(photo) || name?.value)) preserved = true;
      });
      this.querySelector('[data-pet-draft-notice]').hidden = !preserved;
      this.querySelector('[data-pet-multi-help]').hidden = count < 2;
      this.querySelector('[data-pet-layout]').hidden = count < 2;
      this.querySelector('[data-pet-layout-text]').textContent = Array.from({ length: count }, (_, index) => this.querySelector(`[data-pet-group="${index + 1}"] legend`).firstChild.textContent.trim()).join(' → ');
      this.querySelector('[data-pet-portrait]').hidden = !portrait;
      this.querySelector('[data-pet-notes]').disabled = !portrait;
      this.querySelector('[data-pet-collar]').hidden = profile !== 'collar';
      this.querySelector('[data-pet-neck]').disabled = profile !== 'collar';
      this.querySelector('[data-pet-neck]').required = profile === 'collar';
      this.querySelector('[data-pet-lettering]').disabled = profile !== 'collar';
      this.querySelector('[data-pet-consents]').hidden = !portrait;
      this.querySelector('[data-pet-consents]').querySelectorAll('input').forEach((input) => { input.disabled = !portrait; input.required = portrait; });
      const rightsLabel = this.querySelector('[data-pet-rights-label]');
      rightsLabel.hidden = deferred;
      rightsLabel.querySelector('input').disabled = !portrait || deferred;
      rightsLabel.querySelector('input').required = portrait && !deferred;
      this.querySelector('[data-pet-photo-guide]').hidden = !portrait || deferred;
      this.querySelector('[data-pet-quantity-field]').hidden = !portrait;
      this.querySelector('[data-pet-quantity]').disabled = !portrait;
      this.querySelector('[data-pet-spec-notice]').hidden = portrait;
      this.querySelector('[data-pet-enquire]').hidden = profile !== 'collar';
      this.button.hidden = profile === 'collar';
      this.updateReview();
    }
    updateReview() {
      if (!this.specDriven) return;
      const option = this.variant.selectedOptions[0];
      const count = this.selectedPetCount(option);
      const review = this.querySelector('[data-pet-review]');
      const quantity = this.querySelector('[data-pet-quantity]').value || '1';
      review.textContent = `${count ? `${review.dataset.countLabel}: ${count} · ` : ''}${option?.dataset.petSize || ''} · ${quantity} × ${option?.dataset.price || ''}`;
      const names = Array.from(this.querySelectorAll('[data-pet-name]')).filter((input) => !input.matches(':disabled') && input.value.trim()).map((input) => {
        const group = input.closest('[data-pet-group]');
        return `${group.querySelector('legend').firstChild.textContent.trim()}: ${input.value.trim()}`;
      });
      const nameSummary = this.querySelector('[data-pet-summary-names]');
      nameSummary.textContent = names.join(' · ');
      nameSummary.hidden = names.length === 0;
      const photos = Array.from(this.querySelectorAll('[data-pet-photo]')).filter((input) => !input.matches(':disabled') && (input.files.length || this.retainedPhotos.has(input)) && input.closest('[data-pet-group]')?.dataset.petGroup !== 'reference').length;
      const photoCount = this.querySelector('[data-pet-photo-count]');
      photoCount.textContent = this.photosDeferred() && count ? photoCount.dataset.laterLabel : count ? `${photoCount.dataset.label}: ${photos} / ${count}` : '';
    }
    resetSubmission() {
      this.submitting = false;
      this.form.removeAttribute('aria-busy');
      this.status.textContent = '';
      const customisationId = this.querySelector('[data-pet-customisation-id]');
      if (customisationId && !this.editRequested) customisationId.value = crypto.randomUUID();
      this.updateVariant();
    }
    updateFileName(input) {
      const label = input.closest('[data-pet-photo-field]').querySelector('[data-pet-file-name]');
      if (label) label.textContent = input.files[0]?.name || (this.retainedPhotos.has(input) ? label.dataset.savedLabel : label.dataset.emptyLabel);
    }
    clearPhoto(input) {
      const field = input.closest('[data-pet-photo-field]');
      this.retainedPhotos.delete(input);
      const group = input.closest('[data-pet-group]');
      if (group) input.required = !group.disabled && group.dataset.petGroup !== 'reference';
      const oldUrl = this.photoUrls.get(input);
      if (oldUrl) URL.revokeObjectURL(oldUrl);
      this.photoUrls.delete(input);
      const previewImage = field.querySelector('[data-pet-preview-image]');
      previewImage.onload = null;
      previewImage.onerror = null;
      previewImage.removeAttribute('src');
      field.querySelector('[data-pet-preview]').hidden = true;
      field.querySelector('[data-pet-remove]').hidden = true;
      const error = field.querySelector('[data-pet-photo-error]');
      error.textContent = '';
      error.hidden = true;
      input.setCustomValidity('');
      input.removeAttribute('aria-invalid');
      this.updateFileName(input);
      this.updateReview();
    }
    retainPhoto(input, url) {
      this.clearPhoto(input);
      this.retainedPhotos.set(input, url);
      input.required = false;
      const field = input.closest('[data-pet-photo-field]');
      const preview = field.querySelector('[data-pet-preview]');
      preview.querySelector('img').src = url;
      preview.querySelector('p').textContent = input.dataset.savedHint || 'Saved photo — kept unless you replace or remove it.';
      this.updateFileName(input);
      preview.hidden = false;
      field.querySelector('[data-pet-remove]').hidden = false;
      this.updateReview();
    }
    photoError(input, message) {
      this.clearPhoto(input);
      input.value = '';
      this.updateFileName(input);
      input.setCustomValidity(message);
      input.setAttribute('aria-invalid', 'true');
      const error = input.closest('[data-pet-photo-field]').querySelector('[data-pet-photo-error]');
      error.textContent = message;
      error.hidden = false;
      input.closest('[data-pet-photo-field]').querySelector('[data-pet-remove]').hidden = false;
      this.updateReview();
    }
    validatePhoto(input) {
      const file = input.files[0];
      if (!file) return input.validity.valid;
      const permitted = ['image/jpeg', 'image/png', 'image/webp'];
      const validType = permitted.includes(file.type) || (!file.type && /\.(jpe?g|png|webp)$/i.test(file.name));
      if (!validType) {
        this.photoError(input, input.dataset.typeError);
        return false;
      }
      if (file.size > 10 * 1024 * 1024 || file.size === 0) {
        this.photoError(input, input.dataset.sizeError);
        return false;
      }
      return true;
    }
    updatePhoto(input) {
      if (!input.files.length && this.retainedPhotos.has(input)) return;
      this.clearPhoto(input);
      if (!input.files.length || !this.validatePhoto(input)) return;
      const field = input.closest('[data-pet-photo-field]');
      const preview = field.querySelector('[data-pet-preview]');
      const previewImage = field.querySelector('[data-pet-preview-image]');
      preview.querySelector('p').textContent = input.dataset.newHint || 'New photo — included when you save this piece.';
      const url = URL.createObjectURL(input.files[0]);
      this.photoUrls.set(input, url);
      input.setCustomValidity(input.dataset.pendingMessage);
      field.querySelector('[data-pet-remove]').hidden = false;
      previewImage.onload = () => {
        if (this.photoUrls.get(input) === url) {
          input.setCustomValidity('');
          preview.hidden = false;
          this.updateReview();
        }
      };
      previewImage.onerror = () => {
        if (this.photoUrls.get(input) === url) this.photoError(input, input.dataset.decodeError);
      };
      previewImage.src = url;
    }
  }
  customElements.define('pet-studio-customization', PetStudioCustomization);
}

  } catch(e) { console.error(e); }
})();
})();
